import React, { useState, useEffect, useContext } from 'react';
import './Schedule.css';
import { CardScheduleContext } from '../../contexts/CardScheduleContext';
import ScheduleLoadingStatus from './ScheduleLoadingStatus';
import Calendar from '../Calendar/Calendar';
import logComponent from '../../common/logComponent';


export default function ScheduleContent({ reloadAction, setVisibleMonth, onDateClick }) {
  const cardScheduleContext = useContext(CardScheduleContext);
  const [contentData, setContentData] = useState(null);
  const { scheduleVisibleMonth } = cardScheduleContext;

  if (logComponent('ScheduleContent')) { console.debug('ScheduleContent rendered'); }

  useEffect(() => {
    if (logComponent('ScheduleContent')) {console.debug('ScheduleContent useEffect [cardScheduleContext.schedule]'); }
    setContentData(cardScheduleContext.schedule ? [ ...cardScheduleContext.schedule ] : null);
  }, [cardScheduleContext.schedule]);



  return contentData &&
    <div className="Schedule__content">
      <Calendar
        events={contentData}
        visibleMonth={scheduleVisibleMonth}
        setVisibleMonth={setVisibleMonth}
        onDateClick={onDateClick} 
        moduleLoadingStatus={<ScheduleLoadingStatus reloadAction={reloadAction} />}
      />
      <p className="Schedule__instruction">Select a date to see the event schedule.</p>
    </div>;
}